module.exports = __webpack_public_path__ + "img/address.f37ba286.svg";